<template>
  <b-card no-body class="mb-2 mt-4  w-100 ">
    <slot ></slot>
        <b-card-header v-on:click="changeAcording" header-tag="header" class=" w-100 h-100 p-0" role="tab">
              <div  v-b-toggle="id" variant="info" class="head-mes">
                <div class="title-left pl-3">
                  <div class="title-colapse">{{title}}</div>
                </div>
                <div class="componente">
                <i v-if="!changeAngel" class="fas fa-angle-down arrow-angel"></i>
                <i v-if="changeAngel" class="fas fa-angle-up arrow-angel"></i>
              </div>
              </div>
        </b-card-header>
        <b-collapse :id="id" :accordion="id" role="tabpanel" ref="collapse">
          <b-card-body>
            <div>
              <div class="img-flex">
                <div v-for="data in dataImg" v-bind:key="data.id" class="img-body">
                  <div v-on:click="$emit('imageDetails', data.arquivo.arquivo, data.arquivo.extensao == '.pdf')" class="h-100 container-img-card">
                    <i v-if="data.arquivo.extensao == '.pdf'" style="font-size: 70px" class="fas fa-file-pdf"></i>
                    <img  v-if="!(data.arquivo.extensao == '.pdf')" class="mb-2 img-body-body" :src="'data:image/png;base64,' + data.arquivo.arquivo">
                    <div class="img-footer">
                      <div  class="img-title"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-collapse>
  </b-card>
</template>

<script>

import CollapseImageDetails from './collapseImageDetails'
export default CollapseImageDetails

</script>

<style scoped>
.title-left{
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}
.head-mes{
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-between;
}

.edit-img{
  height: 34px;
  top: 15px;
  right: 1px;
  width: 40px;
  color: white;
  background-color: #008148;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}

.check-title{
  height: 20px;
  width: 20px;
  padding-left: 20px;
}
.img-flex{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.title-colapse{
  padding-left: 15px;
}
.img-title{
  color: rgb(255, 255, 255);
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 5;
  align-items: flex-end;
  font-weight: bold;
  padding-bottom: 7px;
}
.componente{
  font-size: 18px;
  color: black;
  padding-top: 9px;
  padding-left: 15px;
}
.arrow-angel{
  font-size: 25px;
  color: rgb(94, 94, 94);
  padding-right: 20px;
  padding-bottom: 10px;
}

.img-body{
  width: 270px;
  height: 185px;
  border-radius: 10px;
  position: relative;
  margin-bottom: 15px;
  cursor: pointer;
  margin-left: 2%;
}

.img-footer{
  position: absolute;
  width: 100%;
  height: 30px;
  background: rgb(120, 120, 120);
  bottom: 0px;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  justify-content: center;
  align-content: center;
}
.img-body-body{
  position: relative;
  height: 100%;
  object-fit: cover;
  width: 100%;
  border-radius: 8px;
  z-index: 0;
}

.img-body-pdf{
  width: 270px;
  height: 185px;
  border-radius: 10px;
  transition: 400ms;
  margin-bottom: 15px;
  cursor: pointer;
  margin-left: 2%;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}

.container-img-card {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pdf-view {
  overflow-x: hidden;
  overflow-y: hidden;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/requests/components/collapseImageDetails/collapseImageDetails.vue